import React, { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ProtectedRoute } from '../common'
import Layout from '../layout'
import { RENDER_INTERVIEW_PAGE } from '../../configs'

const CompanyOverview = lazy(() => import("../company/overview"));
const CreateVacancy = lazy(() => import("../company/create-vacancy"));
const VacancyDetail = lazy(() => import("../company/vacancy-detail"));
const CandidatePage = lazy(() => import("../company/candidate-page"));
const Settings = lazy(() => import("../pages/Settings"));
const SignIn = lazy(() => import("../pages/SignIn"));
const SignUpDirect = lazy(() => import("../pages/SignUpDirect"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const CreateNewPasswordForm = lazy(() => import("../pages/CreateNewPasswordForm"));
const NotFoundURL = lazy(() => import("../not-found-url"));
const CompanySignUpFlow = lazy(() => import("../pages/CompanySignUp"));
const EmailVerificationScreen = lazy(() => import("../pages/EmailVerificationScreen"));
const Interview = lazy(() => import("../pages/Interview"));
const InterviewQuickstart = lazy(() => import("../pages/InterviewQuickstart"));
const InterviewCalendarRequest = lazy(() => import("../pages/InterviewCalendarRequest"));
const ApplicationLanding = lazy(() => import("../pages/Application"));

const App = () => {
  const isApplicationLoaded = useSelector((state) => state.loadingObserver.isLoading);
  const isInterviewPageRendered = JSON.parse(RENDER_INTERVIEW_PAGE);

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isApplicationLoaded}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<Navigate to="/company" replace />} />
          <Route path="/company" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<CompanyOverview />} />
            <Route path="vacatures/nieuw" element={<CreateVacancy />} />
            <Route path="vacatures/:id" element={<VacancyDetail />} />
            <Route path="vacatures/:id/kandidaten/:candidateId" element={<CandidatePage />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/company" replace />} />
          </Route>
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/verify" element={<EmailVerificationScreen />} />
          <Route path="/company/sign-up" element={<CompanySignUpFlow />} />
          <Route path="/apply/:uuid" element={<ApplicationLanding />} />
          {isInterviewPageRendered && <Route path="/interview/quickstart" element={<InterviewQuickstart />} />}
          {isInterviewPageRendered && <Route path="/interview" element={<Interview />} />}
          {isInterviewPageRendered && <Route path="/interview-demo" element={<Interview isDemo/>} />}
          {isInterviewPageRendered && <Route path="/calendar" element={<InterviewCalendarRequest />} />}
          <Route path="/set-new-password" element={<CreateNewPasswordForm />} />
          <Route path="/direct-sign-up" element={<SignUpDirect />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<NotFoundURL />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
